"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.binDocs = void 0;
var binDocs = exports.binDocs = {
  name: 'bin',
  category: 'Utils',
  syntax: ['bin(value)'],
  description: 'Format a number as binary',
  examples: ['bin(2)'],
  seealso: ['oct', 'hex']
};